import { X, Check } from "lucide-react";
import { Reveal, MaskLineInView } from "./Reveal";

const CLASSIC = [
  "Hohe Kosten gleich zu Beginn",
  "Domain, Hosting & Technik separat organisieren",
  "Wartung und Updates selbst im Blick behalten",
  "Bei Problemen oft kein fester Ansprechpartner",
  "Änderungen kosten häufig extra",
];

const OURS = [
  "Ein fester monatlicher Preis – kein großer Betrag vorab",
  "Website, Domain & Hosting aus einer Hand",
  "Technische Wartung übernehmen wir für Sie",
  "Ein persönlicher Ansprechpartner für Ihren Webauftritt",
  "Änderungen je nach Paket bereits inklusive",
];

export default function ProblemSection() {
  return (
    <section className="relative py-14 lg:py-20 border-t border-white/10" data-testid="problem">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <div className="max-w-3xl mb-10">
          <Reveal className="font-tech text-xs uppercase tracking-[0.25em] text-[#FF3B00] mb-6 flex items-center gap-3">
            <span className="h-px w-10 bg-[#FF3B00]" /> Der bessere Weg
          </Reveal>
          <h2 className="font-display text-4xl md:text-6xl leading-[0.98] tracking-tight text-white uppercase mb-6">
            <MaskLineInView>Eine professionelle Website</MaskLineInView>
            <MaskLineInView delay={0.1}>muss keine hohe</MaskLineInView>
            <MaskLineInView delay={0.2} className="text-[#FF3B00]">Anfangsinvestition sein.</MaskLineInView>
          </h2>
          <Reveal delay={0.15} className="text-neutral-300 text-base leading-relaxed">
            Bei klassischen Website-Projekten entstehen oft schon zu Beginn größere Kosten – und
            zusätzlich müssen Domain, Hosting, technische Einrichtung, Wartung und spätere Änderungen
            organisiert werden. Bei Landingsstrategie funktioniert es anders:{" "}
            <span className="text-white">ein monatlicher Preis, alles aus einer Hand.</span>
          </Reveal>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          <Reveal>
            <div className="h-full border border-white/10 p-8 lg:p-10">
              <p className="font-display text-2xl text-neutral-400 mb-8">Der klassische Weg</p>
              <ul className="space-y-4">
                {CLASSIC.map((t) => (
                  <li key={t} className="flex items-start gap-3 text-neutral-500 text-sm">
                    <X size={18} className="text-neutral-600 shrink-0 mt-0.5" /> {t}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="h-full border border-[#FF3B00]/40 bg-[#FF3B00]/[0.04] p-8 lg:p-10">
              <p className="font-display text-2xl text-white mb-8">Mit Landingsstrategie</p>
              <ul className="space-y-4">
                {OURS.map((t) => (
                  <li key={t} className="flex items-start gap-3 text-neutral-200 text-sm">
                    <Check size={18} className="text-[#FF3B00] shrink-0 mt-0.5" /> {t}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
